export default __webpack_public_path__ + "static/epica-4-b1369904ce39601927734e4d58a31996.jpg";